var React = require('react');

function Exclamationmark (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM7.1,1.3h1.8c0.9,0,1.7,0.8,1.5,1.8L9.6,9.7c-0.2,0.6-0.8,1-1.5,1h0c-0.7,0-1.2-0.4-1.5-1L5.5,3.1C5.4,2.2,6.1,1.3,7.1,1.3z","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"13.3","r":"1.4","key":1})]));
}

Exclamationmark.displayName = "Exclamationmark";

Exclamationmark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Exclamationmark;

Exclamationmark.default = Exclamationmark;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/exclamationmark.svg
// module id = ../icon/src/icons/exclamationmark.svg
// module chunks = 0